import React, { useCallback, useContext, useState } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ConfirmationModal } from '@ubeya/shared-web/components';

const CancelLeaveRecordModal = ({ onClose, cancelLeaveRecord, record }) => {
  const { t } = useContext(ConfigContext);
  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = useCallback(async () => {
    setIsLoading(true);
    try {
      await cancelLeaveRecord({ recordId: record.id });
      onClose();
    } finally {
      setIsLoading(false);
    }
  }, [cancelLeaveRecord, record, onClose]);

  return (
    <ConfirmationModal
      title="cancelLeaveRecord"
      body={t('cancelLeaveRecordConfirm')}
      confirmText="cancelRecord"
      cancelText="back"
      onConfirm={onConfirm}
      onClose={onClose}
      loadingConfirm={isLoading}
      isPermanentAction
    />
  );
};

export default CancelLeaveRecordModal;
